/**
 * Supported locales for the customer-facing Trendmulti product.
 *
 * This mirrors the backend definition in `@app/trendmulti-core` (i18n/types.ts).
 * Keep both in sync: adding a locale (RNF-07) means appending it in both places
 * and shipping the matching translation catalogs.
 */
export type SupportedLocale = 'en' | 'pt-BR' | 'pt-PT' | 'es';

/** The full set of locales the product can be operated in. */
export const SUPPORTED_LOCALES: readonly SupportedLocale[] = ['en', 'pt-BR', 'pt-PT', 'es'];

/** Global fallback when neither User nor Company defines a language (RF-14). */
export const DEFAULT_LOCALE: SupportedLocale = 'pt-BR';

/** Native display label shown in the language picker (RF-12). */
export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: 'English',
  'pt-BR': 'Português (Brasil)',
  'pt-PT': 'Português (Portugal)',
  es: 'Español',
};

/** Narrowing guard for untrusted input (persisted values, query params). */
export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
